
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ASA_AnesthesiaRisk',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/ASA_AnesthesiaRisk.vue